export default __webpack_public_path__ + "static/media/use7.47a53eb8.png";